import React from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

import useScrollLayout from './useScrollBox'
import ScrollBoxHorizontal from './ScrollBoxHorizontal'

import { Style } from './style'

const ScrollBox = React.forwardRef(
  ({ className, step, children, renderTop, renderBottom }, ref) => {
    const {
      hasOverflowVertical,
      canScrollUp,
      canScrollDown,
      scrollUp,
      scrollDown,
    } = useScrollLayout({
      ref,
    });
   
    return (
      <React.Fragment>
        {renderTop({ hasOverflowVertical, canScrollUp, step, scrollUp })}
        <Style className={className} ref={ref}>
          {children}
        </Style>
        {renderBottom({ hasOverflowVertical, canScrollDown, step, scrollDown })}
      </React.Fragment>
    );
  }
);

ScrollBox.Horizontal = ScrollBoxHorizontal

ScrollBox.defaultProps = {
  step: 100,
  className: '',
  renderTop: noop,
  renderBottom: noop,
}

ScrollBox.propTypes = {
  step: PropTypes.number,
  className: PropTypes.string,
  renderTop: PropTypes.func,
  renderBottom: PropTypes.func,
}

export default ScrollBox
